<template>
  <main class="report page-main">
    <section class="page-heading-wrap">
      <h3 class="page-heading">{{ $t('consult.form.head') }}</h3>
    </section>

    <section>
      <validation-observer
        ref="observer"
        v-slot="{ invalid }"
        tag="div"
      >
        <form @submit.prevent="submit">
          <div class="support-form">
            <input-form
              id="subject"
              ref="subject"
              v-model="subject"
              :title="$t('consult.form.subject')"
              name="subject"
              :placeholder="$t('consult.form.subjectPlaceholder')"
              type="text"
              autocomplete="off"
              required="required"
              maxlength="50"
            />
            <input-form
              id="name"
              ref="name"
              v-model="name"
              :title="$t('consult.form.name')"
              name="name"
              :placeholder="$t('consult.form.namePlaceholder')"
              type="text"
              autocomplete="off"
              required="required"
              maxlength="50"
            />
            <input-form
              id="mail"
              ref="mail"
              v-model="mail"
              :title="$t('consult.form.email')"
              name="mail"
              :placeholder="$t('consult.form.emailPlaceholder')"
              type="email"
              autocomplete="off"
              required="required"
              maxlength="50"
            />
            <input-form
              id="textarea"
              ref="textarea"
              v-model="textarea"
              :title="$t('consult.form.detail')"
              name="textarea"
              :placeholder="$t('consult.form.detailPlaceholder')"
              type="textarea"
              autocomplete="off"
              required="required"
              maxlength="500"
            />
          </div>

          <div class="support-agree">
            <!--            <div class="agree-check-all">-->
            <!--              <check-box-->
            <!--                id="all"-->
            <!--                v-model="agreeAll"-->
            <!--                text="전체 동의합니다."-->
            <!--                name="agree-all"-->
            <!--                @input="onChangeAgreeAll($event)"-->
            <!--              />-->
            <!--            </div>-->

            <div class="agree-wrap">
              <div class="agree-title">{{ $t('consult.form.privateTitle') }}</div>
              <div class="agree-content">
                <div class="agree-check">
                  <check-box
                    id="private"
                    ref="private"
                    v-model="agreePrivate"
                    :text="$t('consult.form.private')"
                    name="agree-private"
                    required="required"
                  />
                </div>
                <html-view class="agree-term" :value="$t('consult.form.privateValue')" />
                <!--                <div class="agree-term">-->
                <!--                  <strong>개인정보 수집 및 이용에 대한 안내</strong>-->
                <!--                  <p>(주)우아한형제들은 임직원의 불공정한 업무처리, 또는 지위를 이용한 부당한 요구 등에 대한 상담 및 신고접수 시에 최소한의 범위 내에서 아래와 같이 개인정보를 수집·이용합니다.</p>-->
                <!--                  <ol style="margin:12px 0">-->
                <!--                    <li>1. 수집하는 개인정보 항목: 이름, 전자우편주소</li>-->
                <!--                    <li>2. 수집 및 이용 목적: 제휴·문의사항 접수 및 처리결과 회신</li>-->
                <!--                    <li>3. 개인정보의 이용기간: <span style="text-decoration:underline;">목적 달성 후, 해당 개인정보를 지체없이 파기</span></li>-->
                <!--                  </ol>-->
                <!--                  <p>위 개인정보 수집‧이용에 대한 동의를 거부할 권리가 있습니다. 다만 동의를 거부하는 경우 상담 및 신고가 제한될 수 있습니다.</p>-->
                <!--                </div>-->
              </div>
            </div>
          </div>

          <div class="support-btn">
            <button type="submit" class="btn btn-fill btn-wide" :disabled="invalid">{{ $t('consult.form.submit') }}</button>
          </div>
        </form>
      </validation-observer>
    </section>
  </main>
</template>
<script>
import supportForm from '@/mixins/supportForm'
import defendPath from '@/mixins/defendPath'

export default {
  mixins: [supportForm, defendPath],
  watch: {
    agreePrivate (v) {
      this.agreeAll = v
    }
  },
  methods: {
    submit () {
      this.saveQuestion({
        title: this.subject,
        name: this.name,
        email: this.mail,
        content: this.textarea,
        type: 'CONSULT'
      }, 'Consult')
    },
    onChangeAgreeAll (v) {
      if (v) {
        this.agreePrivate = true
        this.agreePrecautions = true
      } else {
        this.agreePrivate = false
        this.agreePrecautions = false
      }
    }
  }
}
</script>
